import { useApi } from '@backstage/core-plugin-api';
import { permissionApiRef } from '../apis/PermissionApi.esm.js';
import { isResourcePermission, AuthorizeResult } from '@backstage/plugin-permission-common';
import useSWR from 'swr';

function usePermission(input) {
  const permissionApi = useApi(permissionApiRef);
  const { data, error } = useSWR(input, async (args) => {
    if (isResourcePermission(args.permission) && !args.resourceRef) {
      return AuthorizeResult.DENY;
    }
    const { result } = await permissionApi.authorize(args);
    return result;
  });
  if (error) {
    return { error, loading: false, allowed: false };
  }
  if (data === void 0) {
    return { loading: true, allowed: false };
  }
  return { loading: false, allowed: data === AuthorizeResult.ALLOW };
}

export { usePermission };
//# sourceMappingURL=usePermission.esm.js.map
